import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-6xl flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
      <span className="font-heading text-7xl font-bold text-primary-500 md:text-9xl">404</span>
      <h1 className="mt-6 font-heading text-xl font-bold text-foreground-950 md:text-3xl">
        抱歉，这个页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面可能已被移除或链接有误。不如回到首页，看看有哪些值得关注的情感题材影视作品。
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-500"
        >
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}